import { ModalFactory, type ModalConfig } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import AvatarUploadModal from './AvatarUpload.vue';

export interface AvatarUploadModalConfig {
  currentAvatar?: string;
  maxSize?: number;
  allowedTypes?: string[];
  onSuccess?(url: string): void;
  onError?(error: Error): void;
  onCancel?(): void;
  title?: string;
  width?: string | number;
  customRequest?: (path: string) => Promise<void>;
  style?: Record<string, string>;
}

export class AvatarUploadModalFactory {
  static modalSymbol = Symbol('avatar-upload-modal');

  static create(config: AvatarUploadModalConfig) {
    const { t: $t } = getI18nService();
    const modalConfig: ModalConfig = {
      title: config.title || $t('shang-chuan-tou-xiang'),
      width: config.width || '420px',
      content: (
        <AvatarUploadModal
          currentAvatar={config.currentAvatar}
          style={config.style}
          customRequest={config.customRequest}
        ></AvatarUploadModal>
      ),
    };

    return ModalFactory.create(modalConfig, AvatarUploadModalFactory.modalSymbol);
  }
}

// 便捷方法
export const showAvatarUploadModal = (config: AvatarUploadModalConfig) => {
  return AvatarUploadModalFactory.create(config);
};
